import config from '../config';

export class WhitelistUserData {
    userId: string = '';
    username: string = '';
    email: string = '';
    enabledAt: number = 0;
}

export class PaginationData {
    previous: string = '';
    next: string = '';
}

export class WhiteListUsersDataResponse {
    data: WhitelistUserData[] = [];
    page: PaginationData = new PaginationData();
}

export class WhitelistGameData {
    enabledAt: number = 0;
}

export const addWhitelistUser = async (
    license: string,
    func: string,
    email: string,
    token?: string,
): Promise<WhitelistUserData> => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/email/${email}/whitelist/${func}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'PUT',
        },
    );
    if (resp.status !== 200) {
        throw new Error('failed to add whitelist user');
    }
    const data = await resp.json();
    return data.data;
};

export const removeWhitelistUser = async (
    license: string,
    func: string,
    userId: string,
    token?: string,
): Promise<any> => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/user/${userId}/whitelist/${func}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: 'DELETE',
        },
    );
    if (resp.status !== 200) {
        throw new Error('failed to remove whitelist user');
    }
};

// TODO: Remove this once we implement proper searching
export const getAllWhitelistUsers = async (
    license: string,
    func: string,
    token?: string,
): Promise<WhiteListUsersDataResponse> => {
    let data: WhitelistUserData[] = [];
    let resp = await getWhitelistUsers(license, func, token);
    data = [...data, ...resp.data];

    let nextPage = resp.page.next;
    while (nextPage) {
        resp = await getWhitelistUsersNextPage(license, func, nextPage, token);
        data = [...data, ...resp.data];
        nextPage = resp.page.next;
    }

    return { data, page: new PaginationData() };
};

export const getWhitelistUsers = async (
    license: string,
    func: string,
    token?: string,
): Promise<WhiteListUsersDataResponse> => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/whitelist/${func}/users?limit=50`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );
    if (resp.status !== 200) {
        throw new Error('failed to get whitelist users');
    }
    const data = await resp.json();
    return data;
};

export const getWhitelistUsersNextPage = async (
    license: string,
    func: string,
    next: string,
    token?: string,
): Promise<WhiteListUsersDataResponse> => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/whitelist/${func}/users?${next}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );
    if (resp.status !== 200) {
        throw new Error('failed to get whitelist users');
    }
    const data = await resp.json();
    return data;
};

export const isWhitelistEnabledForGame = async (
    license: string,
    token?: string,
): Promise<boolean> => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/entities/game/whitelist-status`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        },
    );

    if (resp.status === 404) {
        return false;
    }
    if (resp.status !== 200) {
        throw new Error('failed to get whitelist enable for game');
    }
    const data = await resp.json();
    return data.data.data.IsActive;
};

export const setWhitelistStatus = async (
    newStatus: boolean,
    license: string,
    token?: string,
): Promise<any> => {
    const resp = await fetch(
        `${config.entityManagerURL}/game/${license}/entities/game/whitelist-status`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            method: 'PUT',
            body: JSON.stringify({ IsActive: newStatus }),
        },
    );
    if (resp.status !== 200) {
        throw new Error('failed to set whitelist status for game');
    }
};
